import { Suspense } from 'react';
import { lazyWithRetry } from 'shared/lazy';

// remove lazy when gimmick feature adopted
const NewLearnMoreIcon = lazyWithRetry(() =>
  import('./NewLearnMoreIcon').then(module => ({ default: module.LearnMoreIcon })),
);
interface LearnMoreIconProps {
  productType?: string;
  productSubType?: string;
}

export function LearnMoreIcon(props: LearnMoreIconProps) {
  return <Suspense>{<NewLearnMoreIcon {...props} />}</Suspense>;
}
